<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>far fa-check</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Funder Offer Made</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card flat tile class="ma-0 mb-0">
        <v-card-text>
          <v-form lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout v-if="!showAcceptConfirmation && !showRejectConfirmation">
                <v-btn color="primary" @click="showRejectConfirmation = true">Offer Rejected</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="showAcceptConfirmation = true">Offer Accepted</v-btn>
              </v-layout>
              <v-layout v-if="showAcceptConfirmation">
                <v-flex xs12>
                  <v-card-text>
                    <h3>Customer Offer Accepted</h3>
                    <p>Please come back and update the Platform once funds have been released.</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click.native="showAcceptConfirmation = false">Cancel</v-btn>
                    <v-btn color="success" @click="save('SME OFFER ACCEPTED')">Update</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
              <v-layout v-if="showRejectConfirmation">
                <v-flex xs12>
                  <v-card-title>
                    <h3 class="font-weight-bold">Are you sure this offer has been rejected?</h3>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click.native="showRejectConfirmation = false">Cancel</v-btn>
                    <v-btn color="success" @click="save('SME OFFER REJECTED')">Offer Rejected</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'enquiry-offer-made-dialog',
  props: ['show', 'enquiry'],
  data: () => ({
    showRejectConfirmation: false,
    showAcceptConfirmation: false,
    updates: {
      enquiry_status_id: ''
    }
  }),
  computed: {
    ...mapGetters(['EnquiryStatuses']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['storeFunderEnquiry', 'addNotification']),
    closeDialog() {
      this.dialog = false;
    },
    save(statusName) {
      const enquiryStatus = _.find(this.EnquiryStatuses, ['name', statusName]);
      this.storeFunderEnquiry({
        id: this.enquiry.id,
        updates: {
          enquiry_status_id: enquiryStatus.id
        }
      }).then(() => {
        this.addNotification({
          text: `enquiry updated`
        });
        this.dialog = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
